import { logEvent } from './logEvent';

/**
 * Sprint 1 telemetry taxonomy (LY-004)
 *
 * Keep this small and stable; expand in later sprints.
 */
export type TelemetryArea = 'public' | 'app';

export type TelemetryEventName =
  | 'APP_INIT'
  | 'ROUTE_VIEW'
  | 'CTA_CLICK';

export type TelemetryPayloadByName = {
  APP_INIT: {
    ts: string;
    screen: string;
    path: string;
    area: TelemetryArea;
  };
  ROUTE_VIEW: {
    ts: string;
    path: string;
    area: TelemetryArea;
    from?: string | null;
  };
  CTA_CLICK: {
    ts: string;
    id: string;
    label: string;
    href?: string;
    path: string;
    area: TelemetryArea;
  };
};

function nowIso() {
  return new Date().toISOString();
}

export function getTelemetryArea(pathname: string): TelemetryArea {
  return pathname.startsWith('/app') ? 'app' : 'public';
}

export function trackEvent<TName extends TelemetryEventName>(
  type: TName,
  payload: TelemetryPayloadByName[TName]
) {
  logEvent(type, payload);
}

export function trackAppInit() {
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  trackEvent('APP_INIT', {
    ts: nowIso(),
    screen: `${window.innerWidth}x${window.innerHeight}`,
    path,
    area: getTelemetryArea(window.location.pathname),
  });
}

export function trackRouteView(input: { path: string; from?: string | null; pathname?: string }) {
  const pathname = input.pathname ?? window.location.pathname;
  trackEvent('ROUTE_VIEW', {
    ts: nowIso(),
    path: input.path,
    area: getTelemetryArea(pathname),
    from: input.from,
  });
}

export function trackCtaClick(input: { id: string; label: string; href?: string }) {
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  trackEvent('CTA_CLICK', {
    ts: nowIso(),
    id: input.id,
    label: input.label,
    href: input.href,
    path,
    area: getTelemetryArea(window.location.pathname),
  });
}


